/**
 * Determine if the fullscreen api can be used in the current browser.
 */
export const isFullscreenAvailable = (): boolean => {
    // Fullscreen is not supported on Opera Mini and on IE according to https://caniuse.com/fullscreen.
    if (
        ((/Opera Mini/i).exec(navigator.userAgent))
        || ((/MSIE/i).exec(navigator.userAgent))
    ) {
        return false;
    }

    /*
     * Fullscreen is supported on some versions of iOS on iPad, but not on iPhone,
     * but may become supported on iPhone in the future.
     * The userAgent field on iOS browsers is not useful in determining compatibility.
     * Instead, test if the fullscreen API is available by checking for the existance of the function.
     */
    return !!document.querySelector('#map-with-sidebar')?.requestFullscreen;
};
